import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import TeamController from './team.controller';
import { Layout, Loading } from '../common';
import { Modal, Button as AntButton, Input as AntInput, Select } from 'antd';
import { UserAddOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './styles/team.module.scss';

const { Option } = Select;

/**
 * Team component
 * * @extends {TeamController}
 * @extends {Component}
 */
class Team extends Inherit(TeamController, Component) {
    render() {
        const { 
            user, 
            loading, 
            filteredUsers, 
            searchQuery, 
            showAddMemberModal,
            newMemberEmail,
            newMemberRole,
            usersLoading 
        } = this.state;

        if (loading) {
            return (
                <Layout user={user} fi={user?.fi?.name}>
                    <Loading />
                </Layout>
            );
        }

        return (
            <Layout user={user} fi={user?.fi?.name}>
                <div className={styles.teamContainer}>
                    <div className={styles.header}>
                        <h1 className={styles.title}>Team</h1>
                        
                        <div className={styles.headerActions}>
                            <div className={styles.searchWrapper}>
                                <AntInput
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => this.handleSearchChange(e)}
                                    className={styles.searchInput}
                                    size="large"
                                />
                                <AntButton
                                    type="primary"
                                    icon={<SearchOutlined />}
                                    onClick={() => {}}
                                    className={styles.searchButton}
                                    size="large"
                                />
                            </div>
                            
                            <AntButton
                                type="default"
                                icon={<UserAddOutlined />}
                                onClick={() => this.handleOpenAddMemberModal()}
                                className={styles.addButton}
                                size="large"
                            >
                                Add Team Member
                            </AntButton>
                        </div>
                    </div>

                    <div className={styles.tableContainer}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Role</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {usersLoading ? (
                                    <tr>
                                        <td colSpan="4" className={styles.loadingCell}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : filteredUsers.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className={styles.emptyCell}>
                                            {searchQuery ? 'No team members found matching your search' : 'No team members yet'}
                                        </td>
                                    </tr>
                                ) : (
                                    filteredUsers.map((member) => (
                                        <tr key={member.id || member.email}>
                                            <td>
                                                <div className={styles.memberInfo}>
                                                    <div className={styles.memberName}>{member.name || member.email}</div>
                                                    <div className={styles.memberEmail}>{member.email}</div>
                                                </div>
                                            </td>
                                            <td>{this.getUserRole(member)}</td>
                                            <td>
                                                <span className={member.active ? styles.statusActive : styles.statusInactive}>
                                                    {this.getUserStatus(member)}
                                                </span>
                                            </td>
                                            <td>
                                                <div className={styles.actions}>
                                                    <button
                                                        className={styles.actionButton}
                                                        onClick={() => this.handleSendPasswordReset(member.email)}
                                                        title="Send Password Reset"
                                                    >
                                                        Reset Password
                                                    </button>
                                                    <button
                                                        className={`${styles.actionButton} ${styles.toggleButton}`}
                                                        onClick={() => this.handleDeleteUser(member.id)}
                                                        title="Toggle Access"
                                                    >
                                                        <svg 
                                                            width="16" 
                                                            height="16" 
                                                            viewBox="0 0 24 24" 
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <path d="M12 2v6" />
                                                            <path d="M6.34 6.34a8 8 0 1 0 11.32 0" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Add Team Member Modal */}
                <Modal
                    title="Add a Team Member"
                    open={showAddMemberModal}
                    onCancel={() => this.handleCloseAddMemberModal()}
                    footer={null}
                    className={styles.addMemberModal}
                    width={500}
                >
                    <div className={styles.modalContent}>
                        <p className={styles.modalDescription}>
                            Input the email of the user you wish to allow access your institution
                        </p>
                        
                        <div className={styles.modalInputs}>
                            <AntInput
                                placeholder="email"
                                value={newMemberEmail}
                                onChange={(e) => this.setNewMemberEmail(e.target.value)}
                                size="large"
                                className={styles.emailInput}
                            />
                            
                            <Select
                                value={newMemberRole}
                                onChange={(value) => this.setNewMemberRole(value)}
                                size="large"
                                className={styles.roleSelect}
                            >
                                <Option value="Owner">Owner</Option>
                                <Option value="Admin">Admin</Option>
                                <Option value="Member">Member</Option>
                            </Select>
                        </div>
                        
                        <AntButton
                            type="primary"
                            onClick={() => this.handleInviteMember()}
                            loading={usersLoading}
                            block
                            size="large"
                            className={styles.inviteButton}
                        >
                            Invite
                        </AntButton>
                    </div>
                </Modal>
            </Layout>
        );
    }
}

export default withHooks(Team);

